import { Typography } from '@mui/material';
import { makeStyles } from '@pmp/theme';
import { REQUIRED_FIELD_MARKER } from '@shared/appConstants';
import { ReactNode } from 'react';

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
  },
  hint: {
    color: palette.neutrals[800],
  },
  error: {
    color: palette.error[500],
  },
  inverse: {
    color: palette.common.white,
  },
}));

export type FormLabelProps = {
  required?: boolean;
  label?: ReactNode;
  helperText?: ReactNode;
  descriptionText?: ReactNode;
  name?: string;
  error?: boolean;
  inverse?: boolean;
  className?: string;
  labelClassName?: string;
  children?: ReactNode;
};

const FormLabel = ({
  required,
  label,
  helperText,
  descriptionText,
  name,
  error = false,
  inverse = false,
  className,
  labelClassName,
  children,
}: FormLabelProps) => {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.root, className)}>
      {label && (
        <Typography
          className={cx(labelClassName, inverse && classes.inverse, error && classes.error)}
          variant="subtitle1"
          component="label"
          htmlFor={name}
        >
          {label} {required && REQUIRED_FIELD_MARKER}
        </Typography>
      )}
      {descriptionText && (
        <Typography
          variant="body3"
          className={cx(classes.hint, inverse && classes.inverse, error && classes.error)}
        >
          {descriptionText}
        </Typography>
      )}
      {children}
      {helperText && (
        <Typography
          variant="body3"
          className={cx(classes.hint, inverse && classes.inverse, error && classes.error)}
        >
          {helperText}
        </Typography>
      )}
    </div>
  );
};

export default FormLabel;
